// Minnesotaänger Mini App — v1 immutable state update helper.
// New code (not from telegram-tt). All v1 actions mutate only the `miniapp`
// field of GlobalState; the (unused) telegram-tt tree stays untouched.

import type { GlobalState } from '../types';
import type { MiniAppGlobalState } from './types';

export function updateMiniapp<T extends GlobalState>(
  global: T,
  update: (miniapp: MiniAppGlobalState) => MiniAppGlobalState,
): T {
  return {
    ...global,
    miniapp: update(global.miniapp),
  };
}
